import $ from 'jquery';
import './utils/jquery-events';

import GdprMount from 'tradera-components/alerts/gdpr/gdpr-mount';
import MultiCurrencyBoot from 'components/multi-currency/multi-currency-boot';
import { MainNavigation } from 'static/script/containers/navigation/main-navigation';
import reactAdsLoader from 'tradera-components/ads/boot-react-ads';

export default async initData => {
    window.$ = window.$ || $;
    GdprMount(initData);
    await MultiCurrencyBoot.boot(initData);
    MainNavigation();
    reactAdsLoader(initData);
};
